// extracted by mini-css-extract-plugin
module.exports = {"translationSwitch":"translationswitch-module--translationSwitch--1KShV","label":"translationswitch-module--label--sCesh"};